import { AnalyticsBrowser } from '@segment/analytics-next'
import { createContext } from 'react'

export const AnalyticsSegmentContext = createContext<AnalyticsBrowser | null>(null)
AnalyticsSegmentContext.displayName = 'AnalyticsSegmentContext'
